import React, { useState } from "react";
//import { Link } from "react-router-dom";
import { useScrollPosition } from "../hooks/useScrollPosition";
import useResizeObserver from "../hooks/useResizeObserver";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { MoonFill, SunFill } from "react-bootstrap-icons";
import { mainBody, repos, about, skills } from "../editable-stuff/config.js";
//import ThemeSwitcher from "react-theme-switcher";

const Navigation = React.forwardRef((props, ref) => {
  // const { showBlog, FirstName } = config;
  const { isDarkMode, handleToggleClick } = props;
  const [isTop, setIsTop] = useState(true);
  const [scrollPosition, setScrollPosition] = useState(0);
  const navbarMenuRef = React.useRef();
  const navbarDimensions = useResizeObserver(navbarMenuRef);
  const navBottom = navbarDimensions ? navbarDimensions.bottom : 0;
  //const [isDarkMode, setIsDarkMode] = React.useState(false);

  // const handleToggleClick = () => {
  //   isDarkMode === false
  //   ?setIsDarkMode(true)
  //   :setIsDarkMode(false)
  // }

  useScrollPosition(
    ({ prevPos, currPos }) => {
      if (!navbarDimensions) return;
      currPos.y + ref.current.offsetTop - navbarDimensions.bottom > 5
        ? setIsTop(true)
        : setIsTop(false);
      setScrollPosition(currPos.y);
    },
    [navBottom]
  );

  React.useEffect(() => {
    if (!navbarDimensions || !ref.current) return;
    navBottom - scrollPosition >= ref.current?.offsetTop
      ? setIsTop(false)
      : setIsTop(true);
  }, [navBottom, navbarDimensions, ref, scrollPosition]);

  return (
    <Navbar
      ref={navbarMenuRef}
      className={` fixed-top  ${
        !isTop && !isDarkMode
          ? "navbar-white"
          : !isTop && isDarkMode
          ? "navbar-dark"
          : "navbar-transparent"
      }`}
      expand="lg"
    >
      <Navbar.Brand
        className={isDarkMode ? "color-theme-light" : "brand"}
        style={{
          marginLeft: "10px",
          marginRight: "10px",
        }}
        href={process.env.PUBLIC_URL + "/#home"}
      >
        {`<${mainBody.firstName} />`}

        <div className="themeOne" onClick={handleToggleClick}>
          {isDarkMode ? (
            <SunFill className="sun-themeOne" size={30} />
          ) : (
            <MoonFill className="dark-themeOne" size={25} />
          )}
        </div>
        {
          <div className="themeTwo" onClick={handleToggleClick}>
            {isDarkMode ? (
              <SunFill className="sun-themeTwo" size={30} />
            ) : (
              <MoonFill className=" dark-themeTwo" size={25} />
            )}
          </div>
        }
      </Navbar.Brand>
      <Navbar.Toggle
        aria-controls="basic-navbar-nav"
        className="toggler"
        style={{
          background: isDarkMode && !isTop ? "black" : "whitesmoke",
        }}
      />
      <Navbar.Collapse
        id="basic-navbar-nav"
        // style={{
        //   display: "flex",
        //   justifyItems: "space-between",
        //   border: "2px solid red",
        // }}
        style={{ marginLeft: "10px" }}
      >
        <Nav
          className="mr-auto"
          //style={{ marginRight: "auto", border: "2px solid blue" }}
        >
          {/* {
            <Nav.Link className={`${isDarkMode?"color-theme-light": ""} nav-link lead`}>
              <Link to={process.env.PUBLIC_URL + "/blog"}>Blog</Link>
            </Nav.Link>
          } */}
          {repos.show && (
            <Nav.Link
              className={`${
                isDarkMode ? "color-theme-light" : ""
              } nav-link lead`}
              href={process.env.PUBLIC_URL + "/#projects"}
            >
              Projects
            </Nav.Link>
          )}
          <Nav.Link
            className={`${isDarkMode ? "color-theme-light" : ""} nav-link lead`}
            href={about.resume}
            target="_blank"
            rel="noreferrer noopener"
          >
            Resume
          </Nav.Link>
          {about.show && (
            <Nav.Link
              className={`${
                isDarkMode ? "color-theme-light" : ""
              } nav-link lead`}
              href={process.env.PUBLIC_URL + "/#aboutme"}
            >
              About
            </Nav.Link>
          )}
          {skills.show && (
            <Nav.Link
              className={`${
                isDarkMode ? "color-theme-light" : ""
              } nav-link lead`}
              href={process.env.PUBLIC_URL + "/#skills"}
            >
              Skills
            </Nav.Link>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
});

export default Navigation;
